import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../sections/Hero";
import Pains from "../sections/Pains";
import WhyUs from "../sections/WhyUs";
import Social from "../sections/Social";
import Doctors from "../sections/Doctors";
import Process from "../sections/Process";
import Prices from "../sections/Prices";
import FAQ from "../sections/FAQ";
import FinalCTA from "../sections/FinalCTA";
import MapSection from "../sections/MapSection";
import LeadForm from "../components/LeadForm";

export default function Home() {
  const [showFormModal, setShowFormModal] = useState(false);

  useEffect(() => {
    // Плавный скролл для якорных ссылок (#usp, #prices, #final и т.п.)
    const handler = (e) => {
      const t = e.target.closest("a[href^='#']");
      if (!t) return;
      const href = t.getAttribute("href");
      if (!href || href === "#") return;
      const el = document.querySelector(href);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return (
    <div data-testid="home-page">
      <Header onCtaClick={() => setShowFormModal(true)} />
      <Hero />
      <Pains />
      <WhyUs />
      <Doctors />
      <Process />
      <Prices />
      <Social />
      <FAQ />
      <FinalCTA />
      <MapSection />
      <Footer />

      {showFormModal && (
        <div className="modal-backdrop" onClick={() => setShowFormModal(false)} data-testid="header-form-modal">
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setShowFormModal(false)}
              aria-label="Закрыть"
              data-testid="header-form-close"
            >
              <X size={18} />
            </button>
            <div className="modal-body">
              <LeadForm
                source="header_modal"
                title="Записаться на консультацию"
                subtitle="Перезвоним в течение 15 минут и подберём удобное время визита"
                buttonText="Записаться"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
